import React, { useState, useCallback } from "react";
import styled from 'styled-components'
import Edit from './slateEditor'
import Text from './index'
import useOnClickOutside from 'use-onclickoutside'
import { Transition } from 'react-transition-group';


const Wrapper = styled.div`
    //transition: padding-top 150ms ease, padding-left 150ms ease, padding-bottom 150ms ease;
    //margin-top: ${p => p.state === 'entered' ? '0px' : '-50px'};
    //padding-bottom: ${p => p.state === 'entering' ? '0px' : '-20px'};
`

const Wrapper2 = styled.div`
    //transition: padding-top 150ms ease, padding-left 150ms ease, padding-bottom 150ms ease;
    //padding-top: ${p => p.state === 'exiting' ? '117px' : '0px'};
    //padding-bottom: ${p => p.state === 'exiting' ? '20px' : '0px'};
`

export default props => {
    const { extra, user = {} } = props
    const { editInPortal = false } = extra
    const { accessibility = false } = user
    const [selected, setSelected] = useState(false)
    const [animate, setAnimate] = useState(false)

    const ref = React.useRef(null)
    useOnClickOutside(ref, () => setSelected(false))

    const switchToEdit = useCallback(e => {
        if (editInPortal) {
            return
        }

        setSelected(true)
        //setAnimate(true)
        //setTimeout( () =>  {  setAnimate(false); setSelected(!selected);   }, 250 )
    }, [animate, selected])

    return (
        selected || accessibility ?
            (<Transition in={true} appear={true} timeout={150}>
                {
                    state => (
                        <Wrapper ref={ref} state={state}>
                            <Edit {...props} state={state} />
                        </Wrapper>
                    )
                }
            </Transition>
            )
            : (
                <Transition timeout={150}>
                    {
                        state => {
                            return (
                                <Wrapper2 state={state} onClick={switchToEdit}  >
                                    <Text {...props} />
                                </Wrapper2>
                            )
                        }
                    }
                </Transition>
            )

    )
}